module.exports = __webpack_public_path__ + "img/pr-13.dfab873a.png";